import {Module} from 'vuex';

const payment = {
    namespaced: true,
    state: {
        payment_type: null,
        payment_data: {}
    },
    mutations: {
        setState: (s, value) => s.state = value,
        setPaymentType: (s, value) => s.payment_type = value,
        setPaymentData: (s, value) => s.payment_data = value,
    },
    actions: {
        updatePayment(context, payload) {
            return new Promise((resolve, reject) => {
                const {payment_type, payment_data} = payload;

                if (typeof payment_type === 'undefined' || typeof payment_data === 'undefined') {
                    return reject();
                }

                context.commit('setPaymentType', payment_type);
                context.commit('setPaymentData', payment_data);

                return resolve();
            })
        },
        reset(context) {
            context.commit('setPaymentType', null);
            context.commit('setPaymentData', {});
        }
    }
};

export default payment;
